"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _SwaggerTypes = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/code/routers/xc-ts/SwaggerTypes"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _dbHelpers = require("~/helpers/dbHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Helper function to process a single column and return its swagger field definition
async function processColumnToSwaggerField(context, { column, base, model, sourcesMap, isLookupHelper = false, dbType }, ncMeta = _Noco.default.ncMeta) {
    const field = {
        title: column.title,
        type: 'object',
        virtual: true,
        column
    };
    const source = sourcesMap.get(model.source_id);
    switch(column.uidt){
        case _nocodbsdk.UITypes.LinkToAnotherRecord:
            {
                const colOpt = await column.getColOptions(context, ncMeta);
                if (colOpt) {
                    const relTable = await colOpt.getRelatedTable(context, ncMeta);
                    field.type = undefined;
                    // skip if refTable undefined or cross base link
                    if (relTable && relTable.base_id === context.base_id) {
                        field.$ref = `#/components/schemas/${(0, _dbHelpers.swaggerGetSourcePrefix)(source)}${relTable.title}Request`;
                    }
                }
            }
            break;
        case _nocodbsdk.UITypes.Formula:
            var _column_colOptions_parsed_tree, _column_colOptions;
            // Extract type from parsed tree if available
            if ((_column_colOptions = column.colOptions) == null ? void 0 : (_column_colOptions_parsed_tree = _column_colOptions.parsed_tree) == null ? void 0 : _column_colOptions_parsed_tree.dataType) {
                const formulaDataType = column.colOptions.parsed_tree.dataType;
                switch(formulaDataType){
                    case _nocodbsdk.FormulaDataTypes.NUMERIC:
                        field.type = 'number';
                        break;
                    case _nocodbsdk.FormulaDataTypes.STRING:
                        field.type = 'string';
                        break;
                    case _nocodbsdk.FormulaDataTypes.DATE:
                        field.type = 'string';
                        field.format = 'date-time';
                        break;
                    case _nocodbsdk.FormulaDataTypes.BOOLEAN:
                    case _nocodbsdk.FormulaDataTypes.LOGICAL:
                    case _nocodbsdk.FormulaDataTypes.COND_EXP:
                        field.type = 'boolean';
                        break;
                    case _nocodbsdk.FormulaDataTypes.NULL:
                    case _nocodbsdk.FormulaDataTypes.UNKNOWN:
                    default:
                        field.type = 'string';
                        break;
                }
            } else {
                // Fallback to string if no parsed tree available
                field.type = 'string';
            }
            break;
        case _nocodbsdk.UITypes.Lookup:
            if (isLookupHelper) {
                // For recursive lookup resolution, get the underlying column type
                const colOpt = await column.getColOptions(context, ncMeta);
                if (colOpt) {
                    const lookupCol = await colOpt.getLookupColumn(context);
                    return await processColumnToSwaggerField(context, {
                        column: lookupCol,
                        base,
                        model,
                        sourcesMap,
                        isLookupHelper: true,
                        dbType
                    }, ncMeta);
                }
                field.type = 'object';
            } else {
                // For main lookup processing, determine relation type and structure
                const colOpt = await column.getColOptions(context, ncMeta);
                if (colOpt) {
                    const relationCol = await colOpt.getRelationColumn(context);
                    const relationColOpt = await relationCol.getColOptions(context, ncMeta);
                    const { refContext } = await relationColOpt.getRelContext(context);
                    const lookupCol = await colOpt.getLookupColumn(refContext);
                    const refBase = !relationColOpt.fk_related_base_id || base.id === relationColOpt.fk_related_base_id ? base : await _models.Base.get(refContext, relationColOpt.fk_related_base_id);
                    // Get the type of the lookup column by recursively processing it
                    const lookupField = await processColumnToSwaggerField(refContext, {
                        column: lookupCol,
                        base: refBase,
                        model,
                        sourcesMap,
                        isLookupHelper: true,
                        dbType
                    }, ncMeta);
                    // Determine if this is a single value or array based on relation type
                    if (relationColOpt && (relationColOpt.type === _nocodbsdk.RelationTypes.BELONGS_TO || relationColOpt.type === _nocodbsdk.RelationTypes.ONE_TO_ONE)) {
                        // Single value lookup
                        field.type = lookupField.type;
                        field.format = lookupField.format;
                        field.$ref = lookupField.$ref;
                        field.items = lookupField.items;
                    } else {
                        // Array lookup (HAS_MANY or MANY_TO_MANY)
                        field.type = 'array';
                        if (lookupField.$ref) {
                            field.items = {
                                $ref: lookupField.$ref
                            };
                        } else {
                            field.items = {
                                type: lookupField.type,
                                format: lookupField.format
                            };
                        }
                    }
                } else {
                    // Fallback to object if we can't determine the type
                    field.type = 'object';
                }
            }
            break;
        case _nocodbsdk.UITypes.Rollup:
            field.type = 'number';
            break;
        case _nocodbsdk.UITypes.Links:
            field.type = 'integer';
            break;
        case _nocodbsdk.UITypes.Attachment:
            field.type = 'array';
            field.items = {
                $ref: `#/components/schemas/Attachment`
            };
            field.virtual = false;
            break;
        case _nocodbsdk.UITypes.Email:
            field.type = 'string';
            field.format = 'email';
            field.virtual = false;
            break;
        case _nocodbsdk.UITypes.URL:
            field.type = 'string';
            field.format = 'uri';
            field.virtual = false;
            break;
        case _nocodbsdk.UITypes.LastModifiedTime:
        case _nocodbsdk.UITypes.CreatedTime:
            field.type = 'string';
            field.format = 'date-time';
            break;
        case _nocodbsdk.UITypes.LastModifiedBy:
        case _nocodbsdk.UITypes.CreatedBy:
            field.type = 'object';
            break;
        default:
            field.virtual = false;
            _SwaggerTypes.default.setSwaggerType('3.0', column, field, dbType);
            break;
    }
    return field;
}
const _default = async (context, { columns, base, model, sourcesMap }, ncMeta = _Noco.default.ncMeta)=>{
    // Extract dbtype based on column source
    const dbType = await base.getSources().then((sources)=>{
        var _sources_find, _sources_;
        const sourceId = columns[0].source_id;
        return ((_sources_find = sources.find((s)=>s.id === sourceId)) == null ? void 0 : _sources_find.type) || ((_sources_ = sources[0]) == null ? void 0 : _sources_.type);
    });
    return Promise.all(columns.map(async (c)=>{
        return await processColumnToSwaggerField(context, {
            column: c,
            sourcesMap,
            base,
            model,
            dbType,
            isLookupHelper: false
        }, ncMeta);
    }));
};
